import { advancedStringFilter } from 'src/app/util';
import { Break } from 'src/models';
import { GetBreaksOptions } from '../break/break.service';
import { buildDemoReportUsers, DEMO_REPORT_GROUP_IDS } from './demo-report-users.mock';

function buildDemoBreaks(): Break[] {
  const users = buildDemoReportUsers().filter(user => !user.archived);
  const now = new Date().toISOString();

  return [
    {
      id: 'demo-break-lunch',
      name: 'Lunch',
      type: 'paid',
      active: true,
      public: true,
      archivedAt: '',
      scope: 'company',
      access: [],
      breakLimit: 3600,
      poolMode: 'pooled',
      poolPeriod: 'day',
    },
    {
      id: 'demo-break-coffee',
      name: 'Coffee break',
      type: 'paid',
      active: true,
      public: true,
      archivedAt: '',
      scope: 'tag',
      access: [DEMO_REPORT_GROUP_IDS.engineering],
      breakLimit: 900,
      poolMode: 'per-worklog',
      poolPeriod: 'shift',
    },
    {
      id: 'demo-break-personal',
      name: 'Personal time',
      type: 'unpaid',
      active: true,
      public: false,
      archivedAt: '',
      scope: 'user',
      access: users.slice(0, 3).map(user => user.id),
      breakLimit: 1800,
      poolMode: 'pooled',
      poolPeriod: 'day',
    },
    {
      id: 'demo-break-archived',
      name: 'Old stretch break',
      type: 'paid',
      active: false,
      public: true,
      archivedAt: now,
      scope: 'company',
      access: [],
      breakLimit: 600,
      poolMode: 'per-worklog',
      poolPeriod: 'shift',
    },
  ];
}

/** Break types for the Breaks settings page. */
export function buildMockBreaks(options: GetBreaksOptions = {}): Break[] {
  let breaks = buildDemoBreaks();

  if (options.deleted === 1) {
    breaks = breaks.filter(item => !!item.archivedAt);
  } else {
    breaks = breaks.filter(item => !item.archivedAt);
  }

  if (options['filter[id]']) {
    const ids = String(options['filter[id]']).split(',').filter(Boolean);
    breaks = breaks.filter(item => ids.includes(item.id));
  }

  const keyphrase = options['filter[keyphrase]'] || options['filter[name]'] || options.filter;
  if (keyphrase) {
    breaks = advancedStringFilter(breaks, String(keyphrase), item => [item.name]);
  }

  if (options.convertId) {
    breaks = breaks.map(item => ({ ...item, id: `break:${item.type}:${item.id}` }));
  }

  return breaks.sort((a, b) => a.name.localeCompare(b.name));
}

export function findMockBreak(id: string): Break | undefined {
  const rawId = id.includes(':') ? id.split(':').pop() : id;
  return buildDemoBreaks().find(item => item.id === rawId);
}
